import { render, staticRenderFns } from "./StaffIndividualLeaveAssignmentModal.vue?vue&type=template&id=9e0dad70&scoped=true&"
import script from "./StaffIndividualLeaveAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./StaffIndividualLeaveAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0dad70",
  null
  
)

export default component.exports